// toast.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type ToastType = 'success' | 'error' | 'info' | 'warning';

export interface AppToast {
  id: number;
  type: ToastType;
  title: string;
  message?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private readonly toastsSubject = new BehaviorSubject<AppToast[]>([]);
  readonly toasts$ = this.toastsSubject.asObservable();

  private nextId = 1;

  success(title: string, message?: string): void {
    this.show('success', title, message);
  }

  error(title: string, message?: string): void {
    this.show('error', title, message);
  }

  info(title: string, message?: string): void {
    this.show('info', title, message);
  }

  warning(title: string, message?: string): void {
    this.show('warning', title, message);
  }

  remove(id: number): void {
    this.toastsSubject.next(
      this.toastsSubject.value.filter(x => x.id !== id)
    );
  }

  private show(type: ToastType, title: string, message?: string): void {
    const toast: AppToast = {
      id: this.nextId++,
      type,
      title,
      message
    };

    this.toastsSubject.next([
      ...this.toastsSubject.value,
      toast
    ]);

    setTimeout(() => this.remove(toast.id), 3500);
  }
}